import React from 'react';
import { useSelector } from 'react-redux';
import InnerPageHeader from '../InnerPageHeader/InnerPageHeader';
import ArticleInfoHeader from './ArticleInfoHeader';
import ArticlesRightSide from './ArticlesRightSide';
import ArticleNavbar from './ArticleNavbar';
import ArticleForm from './ArticleForm';

import banner1 from '../../img/articles/independenceContractBanner1.png';
import banner2 from '../../img/articles/independenceContractBanner2.jpg'
import banner3 from '../../img/articles/independenceContractBanner3.png';

const AdvantagesContractCosmetics = () => {
    const articleState = useSelector((state) => state.articles);
    const selectedArticle = articleState.articles.find((item) => item.selected);


    return (
        <React.Fragment>
            <InnerPageHeader />
            <div className="inner-page-main-wrapper">
                <ArticleNavbar />
                <div className="container">
                    <div className="article-page-row">
                        <div className="article-page-content">
                                <article>
                                    {selectedArticle ? 
                                        <ArticleInfoHeader
                                            author={selectedArticle.author}
                                            date={selectedArticle.articleDate.toLocaleDateString('ru')}
                                            time={selectedArticle.readingTime}
                                        />
                                    : null}
                                </article>
                                <article>
                                    <div className="article-table-content-wrap">
                                        <div className="article-table-content">
                                            <h3>Оглавление:</h3>
                                            <ul>
                                                <li><a href="#step1">Варианты сотрудничества</a></li>
                                                <li><a href="#step1">Для кого актуально</a></li>
                                                <li><a href="#step3">Преимущества для малого бизнеса</a></li>
                                            </ul>
                                        </div>
                                    </div>
                                </article>
                                <article>
                                    <div className="inner-page-article-content-wrap">
                                        <div className="inner-page-article-text-content full">
                                            <h3>Преимущества контрактного производства косметики для малого бизнеса</h3>
                                            <p>Контрактное производство косметики – процесс изготовления косметики вашего бренда, осуществляемый на производстве стороннего подрядчика. То есть заказчик делегирует полностью весь процесс на аутсорсинг: от разработки дизайна упаковки и рецептуры до получения готовой продукции. Исполнитель, в свою очередь, обязуется строго соблюдать технологический процесс и контролировать каждый этап производства.</p>
                                            <p>По сути, контрактное производство косметики под своим брендом – отличное решение для компаний, у которых нет или недостаточно собственных ресурсов: ни производственных, ни финансовых, но концептуальных. Этот вариант особенно хорош для небольших новых брендов, только вышедших на рынок и желающих найти свою нишу и конкурировать за целевую аудиторию.</p>
                                        </div>
                                    </div>
                                </article>

                                <article>
                                    <div
                                        className="inner-page-article-content-wrap"
                                    >
                                        <div 
                                            id='step1'
                                            className="inner-page-article-text-content full"
                                        >
                                            <h3>Варианты сотрудничества</h3>
                                            <h4>В рамках контрактного производства есть два варианта сотрудничества:</h4>
                                            <ol>
                                                <li>Заказчик четко понимает, какой продукт хочет получить на выходе. Чаще всего он предоставляет свою рецептуру, которую просит либо использовать строго в том же виде, либо частично доработать. Указываются основные параметры будущего продукта: текстура и цвет, область применения, ингредиенты. В этом случае исполнитель работает в рамках заданной стратегии.</li>
                                                <li>У заказчика есть только пожелания к конечному продукту: примеры дизайнерских решений упаковки, данные о целевой аудитории, оказываемое действие. В этом случае на производителя ложится задача по разработке эксклюзивной формулы косметики. Иногда предлагается выбрать подходящую формулу из готовых рецептур, прошедших проверку и положительно себя зарекомендовавших. Заказчик заполняет подробный бриф, ведутся, как правило, долгие переговоры прежде чем будет достигнуто согласие, и процесс разработки рецептуры будет запущен.</li>
                                            </ol>
                                            <div className="inner-page-article-banner-img-wrap">
                                                <img src={banner1} alt={'Варианты сотрудничества контрактное производство'} />
                                            </div>
                                            <h4 id='step2'>Для кого актуально</h4>
                                            <ul>
                                                <li>Малый бизнес, у которого в большинстве случаев нет собственного производства, технологов, лаборатории – содержать и развивать все это просто нецелесообразно.</li>
                                                <li>Представители среднего и крупного бизнеса, которым требуется срочно вывести на рынок новый продукт. Даже при наличии ресурсов процесс займет много времени.</li>
                                                <li>Компании, имеющие собственную производственную базу, но не способные выпускать продукт высокого качества.</li>
                                            </ul>
                                            <p>Среди заказчиков контрактного производства косметики: бьюти-сфера, сетевые магазины с собственными ТМ, дистрибьюторы профессиональной косметики, отели и санатории, аптечные сети.</p>
                                        </div>
                                    </div>
                                </article>

                                <article>
                                    <div
                                        id='step3'
                                        className="inner-page-article-content-wrap"
                                    >
                                        <div className="inner-page-article-text-content full">
                                            <h3>Преимущества для малого бизнеса</h3>
                                            <h4>Экономия ресурсов</h4>
                                            <p>Намного быстрее и дешевле 
                                                передать производственные процессы в руки налаженного производства.
                                                 Как правило, у малого бизнеса нет необходимых компетенций: знаний в области химии, разработки рецептур, 
                                                 источников ингредиентов, тестирования стабильности продукта, трендов в технологиях и т.д. 
                                                 Малый бизнес хочет быстро и относительно недорого выпустить на рынок качественный, конкурентный продукт. 
                                                 Контрактное производство дает такую возможность.
                                            </p>

                                            <div className="inner-page-article-banner-img-wrap">
                                                <img src={banner2} alt='Контрактное производство косметики преимущества для малого бизнеса' />
                                            </div>

                                            <h4>Возможность сосредоточиться на главном</h4>
                                            <p>У малого бизнеса на старте много задач: 
                                                выстроить организационную структуру, финансы, маркетинг. 
                                                Делегирование объемного и затратного во всех смыслах процесса производства 
                                                стороннему подрядчику освобождает ресурсы на выстраивание бизнес-процессов внутри компании.
                                            </p>

                                            <h4>Шанс найти востребованный продукт</h4>
                                            <p>Есть возможность заказать небольшую партию косметики и протестировать. 
                                                Если продукт не «попадет в рынок», можно без особых финансовых и иных 
                                                потерь запустить новый бренд с другой рецептурой или другим маркетингом. 
                                                Таким образом, цена ошибки не так высока, как если бы это было собственное производство. 
                                                По большому счету, тестировать можно несколько раз, пока не получится удачный конкурентный продукт.
                                            </p>

                                            <div className="inner-page-article-banner-img-wrap">
                                                <img src={banner3} alt='Контрактное производство косметики шанс найти востребованный продукт' />
                                            </div>

                                            <h4>Ответственность производителя</h4>
                                            <p>Бизнесу нужен готовый продукт, который он будет продвигать. 
                                                Не всегда компании нужно знать, как создается рецептура, 
                                                что нужно для качественного состава. 
                                                Производитель берет на себя все риски по технологическому процессу и несет за это ответственность.
                                            </p>

                                            <h4>Важно</h4>
                                            <p>Для достижения эффективного результата важно выбрать надежного подрядчика. 
                                                Рекомендуется выбирать производителя с опытом, собственной лабораторией, штатом 
                                                профессиональных технологов, использующего безопасные ингредиенты и 
                                                разбирающегося в последних тенденциях индустрии красоты. 
                                            </p>
                                            <p>Наша компания приглашает к сотрудничеству представителей малого бизнеса. Получите подробную информацию у наших специалистов.</p>
                                        </div>
                                    </div>
                                </article>


                                <ArticleForm />
                        </div>
                        <ArticlesRightSide 
                            selectedArticle={selectedArticle}
                        />
                    </div>
                </div>
            </div>
           
        </React.Fragment>
    )
};


export default AdvantagesContractCosmetics;